import { Link } from "react-router";
import DealForm from "src/dm/pages/DealForm/DealForm";

const NewDealPage = () => (
  <div>
    <Link to="/" style={{ display: "inline-block", marginBottom: "0.75rem", fontSize: "0.85rem", color: "#0a3d62", textDecoration: "none" }}>
      ← Dashboard
    </Link>
    <DealForm mode={{ kind: "create" }} />
  </div>
);

export default NewDealPage;
